import {
  addDays,
  formatParamDate,
  getFirstDayOfQuarter,
  getFourtyFiveDaysAgo,
  getSevenDaysFromNow,
} from 'app/utils/lib/dates';

const today = new Date();

export const defaultDates = {
  creditLimitExceeded: {
    beginDate: formatParamDate(getFirstDayOfQuarter()),
    endDate: formatParamDate(today),
  },
  creditLimitExposure: {
    beginDate: formatParamDate(getFirstDayOfQuarter()),
    endDate: formatParamDate(today),
  },
  invoicePayDateChangeReport: {
    endDate: formatParamDate(today),
    startDate: formatParamDate(getFirstDayOfQuarter()),
  },
  invoices: {
    fromDate: formatParamDate(getFirstDayOfQuarter()),
    toDate: formatParamDate(today),
  },
  misdirectedPayments: {
    fromDate: formatParamDate(addDays(today, -1)),
    toDate: formatParamDate(today),
  },
  noaCoachableReport: {
    fromDate: formatParamDate(getFourtyFiveDaysAgo()),
    toDate: formatParamDate(today),
  },
  noaSearchList: {
    fromDate: formatParamDate(getFourtyFiveDaysAgo()),
    toDate: formatParamDate(today),
  },
  payorInvoiceBatchReview: {
    endDate: formatParamDate(getSevenDaysFromNow()),
    startDate: formatParamDate(today),
  },
};
